import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonButton,
  IonModal,
} from "@ionic/react";
import React from "react";
import { useState } from "react";
import CodeResentModal from "../../components/modals/code-resent-modal";
function SignupCode() {
  const [cancelModal, setShowModal1] = useState(false);
  const [showModal, setShowModal] = useState(false);
  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="code-resent-modal"
        backdropDismiss={false}
        isOpen={showModal}
        placeholder={undefined}
      >
        <CodeResentModal setShowModal={setShowModal}></CodeResentModal>
      </IonModal>
      <IonModal
        className="cancel-modal"
        backdropDismiss={false}
        isOpen={cancelModal}
        placeholder={undefined}
      >
        {/* <CancelModal setShowModal1={setShowModal1} actionType={ActionType.SuccessPasswordReset} reset={null}></CancelModal> */}
        {/* <SuccessFailed 
        actionType={actionType1}
        /> */}
      </IonModal>
      <IonContent placeholder={undefined} className="slide-in-right">
        <IonGrid className="container top-spacing" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="top-inner-sec login-pages-space">
                <div className="left-arrow">
                  <svg
                    className="svg-icons"
                    width="16"
                    height="26"
                    viewBox="0 0 16 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.8738 21.9379L5.75957 13.0063L14.8867 4.0621L14.8867 4.06211L14.8903 4.05847C15.706 3.24249 15.7059 1.92345 14.8738 1.10795C14.0466 0.297348 12.7153 0.297348 11.8881 1.10795L1.02777 11.7507C0.324078 12.4403 0.324078 13.5597 1.02777 14.2493L11.8881 24.892C12.7153 25.7027 14.0466 25.7027 14.8738 24.892C15.7066 24.0759 15.7066 22.754 14.8738 21.9379Z"
                      fill="#31344E"
                      stroke="black"
                    />
                  </svg>
                </div>
                <h1>New User Sign Up</h1>
                <p>
                  Email confirmed!<br></br>
                  <br></br>
                  Please enter the OTP code that was sent to your email.
                </p>
              </div>
              <form>
                <div className="field-wrap error-wrap">
                  <IonLabel className="label" placeholder={undefined}>
                    OTP Code *
                  </IonLabel>
                  <IonInput
                    className="input-field"
                    type="text"
                    placeholder="Enter code"
                  ></IonInput>
                </div>
                <div
                  className="field-links resend-code"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <span>Resend code</span>
                </div>
                <div className="btn-wrap-sec two-btns extra-btn-space-wrap">
                  <IonButton
                    className="generic-btn generic-btn-outline"
                    placeholder={undefined}
                  >
                    Cancel
                  </IonButton>
                  <IonButton
                    className="generic-btn disable-btn"
                    type="submit"
                    placeholder={undefined}
                  >
                    Confirm
                  </IonButton>
                </div>
              </form>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
}
export default SignupCode;
